import {Component, inject} from '@angular/core'
import {LogoComponent, SpbAccessibleLinkDirective, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {HemnetService} from '../../services/hemnet.service'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    LogoComponent,
    SpbAccessibleLinkDirective,
    ToggleButtonComponent
  ]
})
export class HeaderComponent {
  public readonly service = inject(HemnetService)
  protected readonly environment = environment
}
